import React from 'react';
import CargarCapacitaciones from '../pages/CargarCapacitaciones';
import Navbar from '../components/Navbar';

const CapacitacionesAdmin = ({ usuario }) => {
  return (
    <div>
      <Navbar />
      <CargarCapacitaciones usuario={usuario} />
    </div>
  );
};

export default CapacitacionesAdmin;
